import { Info, X } from 'lucide-react';
import { useNotification } from '@/core/context/NotificationContext';
import ReleaseDialog from '@/shared/components/ReleaseDialog/ReleaseDialog';

export default function ReleaseBanner() {
  const {
    notification,
    isDismissed,
    isDialogOpen,
    dismissNotification,
    openDialog,
    closeDialog,
  } = useNotification();

  if (!notification || isDismissed) {
    return null;
  }

  return (
    <>
      <div
        role="alert"
        className="flex items-center gap-3 border-b bg-primary/10 px-4 py-2 text-sm"
      >
        <Info className="h-4 w-4 shrink-0 text-primary" />
        <button
          type="button"
          onClick={openDialog}
          className="flex-1 text-left hover:underline cursor-pointer text-foreground"
        >
          <span className="font-medium">{notification.version}:</span>{' '}
          {notification.notificationMessage}
        </button>
        <button
          type="button"
          onClick={dismissNotification}
          className="shrink-0 rounded-sm p-1 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Dismiss notification"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <ReleaseDialog
        open={isDialogOpen}
        onClose={closeDialog}
        markdown={notification.fullMarkdown}
        version={notification.version}
        releaseDate={notification.releaseDate}
      />
    </>
  );
}
